module.exports = __webpack_public_path__ + "6e1ade20925014f03b121fffe8dda57d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/antlers-s.png
// module id = 2150
// module chunks = 0